// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Account Tracking',
  subtitle: 'Account management and currency tracking',
  newAccount: 'New Account',
  editAccount: 'Edit Account',
  accountName: 'Account Name',
  accountNamePlaceholder: 'Ex: Cash, Bank Account',
  initialBalance: 'Initial Balance',
  balance: 'Balance',
  account: 'Account',
  selectAccount: 'Select Account',
  allAccounts: 'All Accounts',
  income: 'Income',
  expense: 'Expense',
  onlyIncome: 'Income Only',
  onlyExpense: 'Expense Only',
  timeBasis: 'Time Basis',
  analysis: 'Analysis',
  details: 'Details',
  month: 'Month',
  year: 'Year',
  profitLoss: 'Profit/Loss',
  transactionCount: 'Transaction Count',
  transactions: 'Transactions',
  newTransaction: 'New Transaction',
  editTransaction: 'Edit Transaction',
  addTransaction: 'Add Transaction',
  transactionType: 'Transaction Type',
  incomeType: 'Income',
  expenseType: 'Expense',
  descriptionPlaceholder: 'Transaction description...',
  convertCurrency: 'Convert Currency',
  sourceAccount: 'Source Account',
  targetAccount: 'Target Account',
  sourceAmount: 'Source Amount',
  targetAmount: 'Target Amount',
  exchangeRate: 'Exchange Rate',
  enterOneAmount: 'Enter either source or target amount',
  convert: 'Convert',
  create: 'Create',
  unknown: 'Unknown',
  noAccounts: 'No accounts yet',
  noAccountsDesc: 'Start by adding a new account.',
  noTransactions: 'No transactions yet',
  noTransactionsDesc: 'Start by adding a transaction.',
  noDataForFilters: 'No data found for selected filters.',
  accountCreated: 'Account successfully created',
  accountUpdated: 'Account successfully updated',
  accountDeleted: 'Account successfully deleted',
  transactionCreated: 'Transaction successfully added',
  transactionUpdated: 'Transaction successfully updated',
  transactionDeleted: 'Transaction successfully deleted',
  currencyConverted: 'Currency successfully converted',
  fetchError: 'Data fetch error',
  fetchErrorMsg: 'Data could not be retrieved',
  fillAccountFields: 'Please enter account name and currency',
  fillAllFields: 'Please fill all fields',
  createAccountError: 'Account creation error',
  createAccountErrorMsg: 'Account could not be created',
  updateAccountError: 'Account update error',
  updateAccountErrorMsg: 'Account could not be updated',
  deleteAccountError: 'Account deletion error',
  deleteAccountErrorMsg: 'Account could not be deleted',
  confirmDeleteAccount: 'Are you sure you want to delete this account?',
  createTransactionError: 'Transaction addition error',
  createTransactionErrorMsg: 'Transaction could not be added',
  updateTransactionError: 'Transaction update error',
  updateTransactionErrorMsg: 'Transaction could not be updated',
  deleteTransactionError: 'Transaction deletion error',
  deleteTransactionErrorMsg: 'Transaction could not be deleted',
  confirmDeleteTransaction: 'Are you sure you want to delete this transaction?',
  selectBothAccounts: 'Please select source and target accounts',
  enterValidRate: 'Please enter a valid exchange rate',
  enterAmount: 'Please enter either source or target amount',
  sourceAccountNotFound: 'Source account not found',
  insufficientBalance: 'Insufficient balance',
  convertErrorMsg: 'Currency could not be converted',
  needTwoAccounts: 'At least 2 active accounts required for currency conversion',
  goldRateNotFound: 'Gold rate not found.',
  currencyRateNotFound: 'Rate not found.',
  exchangeRateError: 'Exchange rate information could not be retrieved'
};
